import PropTypes from 'prop-types';

import DiscoverSection from './DiscoverSection/DiscoverSection';

import { PosgraduatesDiscover } from 'constants/posgraduatesDiscover';
import { DegreesDiscover } from 'constants/degreesDiscover';

import classes from './Discover.module.css';

const Discover = props => {
  return (
    <div className={classes.storeContainer}>
      <DiscoverSection
        title="Libros"
        link="books"
        items={props.itemsStore.books.featured}
        section="book"
        changeSection={props.changeSection}
      />
      <DiscoverSection
        title="Cursos y Diplomados"
        link="courses"
        items={props.itemsStore.coursesCerts.featured}
        section="courses"
        changeSection={props.changeSection}
      />
      <DiscoverSection
        title="Licenciaturas"
        link="degrees"
        items={DegreesDiscover}
        section="degree"
        changeSection={props.changeSection}
      />
      <DiscoverSection
        title="Posgrados"
        link="posgrados"
        items={PosgraduatesDiscover}
        section="posgrado"
        changeSection={props.changeSection}
      />
    </div>
  );
};

Discover.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemsStore: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  changeSection: PropTypes.func
};

export default Discover;
